import { render, staticRenderFns } from "./ScreenDesign7.vue?vue&type=template&id=7c8af672&scoped=true"
import script from "./ScreenDesign7.vue?vue&type=script&lang=js"
export * from "./ScreenDesign7.vue?vue&type=script&lang=js"
import style0 from "./ScreenDesign7.vue?vue&type=style&index=0&id=7c8af672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8af672",
  null
  
)

export default component.exports